import { colors } from '../../../../../../../constants'

const ClassProgress = ({ color, title, value, percent, className }) => {
  const colorTheme = colors[color]

  return (
    <div
      className={`p-[10px] flex flex-col items-start justify-start w-full ${colorTheme.block} rounded-md ${className}`}
    >
      <div className={`w-full flex items-center justify-between !mb-1 ${colorTheme.text}`}>
        <span className="text-xs">{title}</span>
        <span className="text-[10px] font-semibold">
          {value} ({percent}%)
        </span>
      </div>
      <div className={`h-[10px] w-full ${colorTheme.progressBar.outer} rounded-sm overflow-hidden`}>
        <div
          className={`h-full ${colorTheme.progressBar.inner}`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}

export default ClassProgress
